
export function parseDuration(durationObject: {[key: string]: number}): string { 
  try {
    let organizedDuration = '';
    if ('days' in durationObject) {
      organizedDuration += `${durationObject['days']}d `;
    }
    if ('hours' in durationObject) {
      organizedDuration += `${durationObject['hours']}h `;
    }
    if ('minutes' in durationObject) {
      organizedDuration += `${String(durationObject['minutes'])}m`;
    }
        
    return organizedDuration;
  }
  catch(error) {
    console.error(`parseDuration() error while trying to parse the duration object: ${durationObject}`);
    return "";
  };
}

export function parseLocation(locationObject: any): string { 
return locationObject['name'] + ", " + locationObject['city_name'] + ", " + locationObject['country'];
}